import React from 'react';
import { useNavigate } from 'react-router-dom';
import iconLike from '../../assets/figma-home/icon-like.svg';
import { useWishlist } from '../../context/WishlistContext';
import { useLanguage } from '../../context/LanguageContext';
import { localizeProduct } from '../../utils/localizeProduct';

// Figma-styled product card (grey card, centered image, "Buy Now" button).
// Used by the curated Home rows and the Photobooks catalog page.
const FigmaProductCard = ({ product: rawProduct }) => {
  const navigate = useNavigate();
  const { isWishlisted, toggleWishlist } = useWishlist();
  const { t, lang } = useLanguage();
  const product = localizeProduct(rawProduct, lang);
  const hasDiscount = product.originalPrice && product.originalPrice > product.price;
  const discountPercent = hasDiscount
    ? Math.round((1 - product.price / product.originalPrice) * 100)
    : 0;
  const image = product.imageUrls && product.imageUrls[0];
  const liked = isWishlisted(product.id);

  return (
    <div className="figma-product-card" onClick={() => navigate(`/product/${product.id}`)}>
      <div className="figma-product-image">
        <button
          type="button"
          className={`figma-like-btn ${liked ? 'active' : ''}`}
          aria-label={liked ? t('card.removeWish') : t('card.addWish')}
          onClick={(e) => { e.stopPropagation(); toggleWishlist({ id: product.id, name: product.name, price: product.price, image }); }}
        >
          <img src={iconLike} alt="" className="figma-like-icon" />
        </button>
        {image && <img src={image} alt={product.name} loading="lazy" />}
      </div>
      <div className="figma-product-info">
        <p className="figma-product-name">{product.name}</p>
        <p className="figma-product-price">
          €{product.price?.toFixed(2)}
          {hasDiscount && <span className="figma-product-discount"> -{discountPercent}%</span>}
        </p>
        <button className="figma-product-btn" onClick={(e) => { e.stopPropagation(); navigate(`/product/${product.id}`); }}>
          {t('card.view')}
        </button>
      </div>
    </div>
  );
};

export default FigmaProductCard;
